import type { GetClientsQuery } from "@src/__generated__/urql-graphql";

type TClient = NonNullable<GetClientsQuery["clients"]>["data"][0];
type TBrandProjectId = TClient["brands"][0]["projects"][0]["id"];

export class ClientListItemModel {
  id: TClient["id"];
  name: TClient["name"];
  workspaceCompany: TClient["workspaceCompany"];
  image: NonNullable<TClient["image"]>["urls"]["thumbnail"];
  responsibleManager: TClient["responsiblePerson"];
  brands: TClient["brands"];
  contacts: TClient["contacts"];
  projectCount = 0;

  constructor(client: TClient) {
    this.id = client.id;
    this.name = client.name;
    this.image = client.image?.urls.thumbnail;
    this.responsibleManager = client.responsiblePerson;
    this.brands = client.brands;
    this.contacts = client.contacts;
    this.workspaceCompany = client.workspaceCompany;

    const brandCount = client.brands.length;

    for (let i = 0; i < brandCount; i++) {
      const projectIds = new Set<TBrandProjectId>();
      const projects = client.brands[i].projects;
      const projectCount = projects.length;

      for (let j = 0; j < projectCount; j++) {
        projectIds.add(projects[j].id);
      }

      this.projectCount += projectIds.size;
    }
  }
}
